// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7762bdf5","223":"9771d7d1","453":"2810a3a5","455":"297f6f8e"}[chunkId] + ".chunk.js";
};